import styled from 'styled-components';

export default styled.a`
  color: #767676;
  text-decoration-color: #767676;
`;
